export interface IModelResponse<T = any> {
  data?: T;
  message?: string;
  totalItems?: number;
}

export class ModelResponse<T = any> {
  data?: T;
  message?: string;
  totalItems?: number;

  constructor(props = {} as IModelResponse) {
    props = props ?? {} as IModelResponse
    this.data = props.data;
    this.message = props.message;
    this.totalItems = props.totalItems;
  }
}